import React, { Component } from 'react';

import Layout from './hoc/Layout/Layout'

import {Route, Switch, Redirect} from 'react-router-dom';

import Intro from './components/Intro/intro';

import {connect} from 'react-redux';

import Logout from './containers/auth/Logout/logout';

import * as actions from './store/actions/exporter';

import asyncComponent from './hoc/asyncComponent';



const AsyncAuth=asyncComponent(()=> {
    
    return import('./containers/auth/auth');
});

const AsyncEvents=asyncComponent(()=> {
    
    return import('./components/Events/events');
});

const AsyncContact=asyncComponent(()=> {
    
    return import('./components/Contact/contact');
});

const AsyncInfo=asyncComponent(()=> {
    
    return import('./containers/DriverInfo/DriverInfo');
});

const AsyncDrivers=asyncComponent(()=> {
    
    return import('./components/Drivers/drivers');
});

const AsyncHOF=asyncComponent(()=> {
    
    return import('./components/HOF/hof');
});

const AsyncTeams=asyncComponent(()=> {
    
    return import('./components/Teams/teams');
});

const AsyncTiles=asyncComponent(()=> {
    
    return import('./components/Contact/Tiles/tiles');
});



class App extends Component {
    
    
     componentDidMount(){
         
        
        this.props.onTryAutoSignup();
         
         const events={
             
             event1: 'May 03, 2020 09:30:00 UTC-0700',
             event2: 'May 10, 2020 09:30:00 UTC-0700',
             event3: 'May 17, 2020 09:30:00 UTC-0700',
             event4: 'May 24, 2020 09:30:00 UTC-0700',
             event5: 'May 31, 2020 09:30:00 UTC-0700',
             event6: 'Jun 07, 2020 09:30:00 UTC-0700',
             event7: 'Jun 14, 2020 09:30:00 UTC-0700',
             event8: 'Jun 21, 2020 09:30:00 UTC-0700',
             event9: 'Jun 28, 2020 09:30:00 UTC-0700',
             event10: 'Jul 05, 2020 09:30:00 UTC-0700'
         }
         
         localStorage.setItem('events', JSON.stringify(events))
       
    }
    
    componentDidUpdate(){
        
        
                 let userStatusCheck=localStorage.getItem('id');

        
        if(userStatusCheck===this.props.userId && this.props.isLogged){
             
             this.props.onExistingSet(this.props.userId);
         }
    }
    
  render() {
      
      let routes=(
          
         <Switch>
        
                <Route path='/' exact component={Intro} />
                <Route path='/hof' component={AsyncHOF} />
                <Route path='/teams' component={AsyncTeams} />
                <Route path='/auth' component={AsyncAuth} />
                <Route path='/contact' component={AsyncContact} />
                <Route path='/tiles' component={AsyncTiles} />
                <Route path='/events' component={AsyncEvents} />
                <Redirect to='/'/>
        
            </Switch>
      );
      
      if(this.props.isLogged){
          
          routes=(
          
         <Switch>
        
                <Route path='/' exact component={Intro} />:null}
                <Route path='/logout' component={Logout} />
                {!this.props.isExisting && this.props.currentUser!=='visitor@gmail.com'? <Route path='/info' component={AsyncInfo} />:null}
                <Route path='/drivers' component={AsyncDrivers} />
                <Route path='/auth' component={AsyncAuth} />
                <Route path='/hof' component={AsyncHOF} />
                <Route path='/teams' component={AsyncTeams} />
                <Route path='/contact' component={AsyncContact} />
                <Route path='/tiles' component={AsyncTiles} />
                <Route path='/events' component={AsyncEvents} />
        
            </Switch>
      );
      }
      
      
    return (
        
        <Layout>
        
            {routes}
           
        </Layout>
     
    );
  }
}


const mapStateToProps=state=>{//mapStateToProps is commonly used name, but you could name it differently. The state is Redux state. Note: create this constant after the class above
    
    return {
        isLogged: state.auth.token !== null,
        isExisting: state.fetch.existing, //using locaStorage check instead because that data isn't lost on refresh
        userId: state.auth.userId,
        currentUser: state.auth.user
    };
}

const mapDispatchToProps=dispatch=> {
    
    return {
        
       onTryAutoSignup: ()=> dispatch(actions.authCheckState()),
        onExistingSet: (userId)=> dispatch(actions.existingStatusUpdate(userId))

        
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js